import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/`,
  timeout: parseInt(process.env.VUE_APP_API_TIMEOUT, 10),
  headers: {
    Accept: "application/json"
  }
});

export { api };



// WEBPACK FOOTER //
// ./src/app/api.js